import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app_body" }
const _hoisted_2 = {
  key: 0,
  class: "statement_detail"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-address-card" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-person-walking-arrow-right" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "app_main",
      onMouseup: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mouseup_do && _ctx.mouseup_do(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ])
    ], 32),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "statement_element",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.lk_go()))
          }, [
            _hoisted_3,
            _createTextVNode("  Личный кабинет ")
          ]),
          _createElementVNode("div", {
            class: "statement_element",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.lk_exit()))
          }, [
            _hoisted_4,
            _createTextVNode("  Выйти ")
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}